<template>
    <b-card class="mb-5">
        <b-row>
            <b-col md="6">
                <h3>{{$route.name}} {{model.type}}</h3>
                <b-breadcrumb>
                    <b-breadcrumb-item><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item>
                    <b-breadcrumb-item><router-link to="/vehicle">Vehicle Dashboard</router-link></b-breadcrumb-item>
                    <b-breadcrumb-item @click="goBack()">Detail Vehicle</b-breadcrumb-item>
                    <b-breadcrumb-item active>{{ $route.name }} {{model.type}}</b-breadcrumb-item>
                </b-breadcrumb>
            </b-col>
            <b-col md="6" class="mt-3 text-right">
                <b-button v-b-tooltip.hover.top title="Download to Excel" @click="doExportToExcel" variant="info" class="btn-download float-right"><font-awesome-icon icon="download"/></b-button>
                <b-button v-if="model.status !== 'Paid'" v-b-tooltip.hover.top title="Pay" variant="primary" class="mr-1 float-right" @click="showModalPay('pay')"><font-awesome-icon icon="donate"></font-awesome-icon></b-button>
            </b-col>
        </b-row>
        <div class="border-bottom mb-3" />
        <template v-if="isLoading">
            <div class="d-flex justify-content-center mb-5 mt-5 pt-5 pb-5">
                <b-spinner style="width: 3rem; height: 3rem;" variant="primary" label="Loading..."></b-spinner>
            </div>
        </template>
        <template v-else>
            <b-form class="mt-2">
                <b-row>
                    <b-col md="6">
                        <b-row>
                            <b-col md="4"><label class="labels">Merk</label></b-col>
                            <b-col md="8"><p>{{ model.vehicle !== null ? model.vehicle.merk : '-' }}</p></b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4"><label class="labels">Model</label></b-col>
                            <b-col md="8"><p>{{ model.vehicle !== null ? model.vehicle.model : '-' }}</p></b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4"><label class="labels">Plate</label></b-col>
                            <b-col md="8"><p>{{ model.vehicle !== null ? model.vehicle.plate : '-' }}</p></b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4"><label class="labels">bill Number</label></b-col>
                            <b-col md="8"><p>{{ model.billNumber !== null ? model.billNumber : '-' }}</p></b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4"><label class="labels">type</label></b-col>
                            <b-col md="8"><p>{{ model.type !== null ? model.type : '-' }}</p></b-col>
                        </b-row>
                    </b-col>
                    <b-col md="6">
                        <b-row>
                            <b-col md="4" v-if="model.type === 'Service'"><label class="labels">Service Date</label></b-col>
                            <b-col md="4" v-else-if="model.type === 'Penalty'"><label class="labels">Penalty Date</label></b-col>
                            <b-col md="4" v-else><label class="labels">Repair Date</label></b-col>
                            <b-col md="8"><p>{{ model.options !== null ? model.options : '-' }}</p></b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4"><label class="labels">paid Date</label></b-col>
                            <b-col md="8"><p>{{ model.paidDate !== null ? model.paidDate : '-' }}</p></b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4"><label class="labels">amount</label></b-col>
                            <b-col md="8"><p>{{ model.amount !== null ? formatPrice(model.amount) : '-' }}</p></b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4"><label class="labels">note</label></b-col>
                            <b-col md="8"><p>{{ model.note !== null ? model.note : '-' }}</p></b-col>
                        </b-row>
                        <b-row v-if="model.type === 'Repair'">
                            <b-col md="4"><label class="labels">Status</label></b-col>
                            <b-col md="8"><p><b-badge :variant="getStatusColor(model.status)">{{getStatusName(model.status)}}</b-badge></p></b-col>
                        </b-row>
                        <b-row v-else>
                            <b-col md="4"><label class="labels">Status</label></b-col>
                            <b-col md="8"><p><b-badge :variant="getStatusColor(model.status)">{{model.status}}</b-badge></p></b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="mt-3 mb-2">
                        <h5>Photo</h5>
                    </b-col>
                    <b-col md="12">
                        <b-row v-if="model.vehicleBillPhoto === null || model.vehicleBillPhoto === 'null' || model.vehicleBillPhoto === ''">
                            <b-col md="3 mb-2">
                                <p class="text-secondary text-center border border-radius p-5 ml-0 mt-0"><i>No Photo Submitted</i></p>
                            </b-col>
                            <b-col md="1 mt-5 float-right">
                                <b-button variant="primary" class="float-right btn-custom" @click="showModal()"><font-awesome-icon icon="plus"/></b-button>
                            </b-col>
                        </b-row>
                        <viewer v-else>
                            <b-row>
                                <b-col md="5 mb-4">
                                    <b-img :src="model.vehicleBillPhoto" class="img-responsive mt-2 ml-0" width="300" height="200"/>
                                </b-col>
                            </b-row>
                        </viewer>
                    </b-col>
                </b-row>
            </b-form>
            <b-modal ref="my-modal" centered hide-footer :title="(model.id === '' ? 'Add' : 'Edit') + ' Service Photo'">
                <form v-on:submit.prevent="doSendPhoto">
                    <label>Photo *</label>
                    <b-form-file :required="true" label="Photo" v-model="model.vehicleBillPhoto" for-input="vehicleBillPhotoroupFile" :error="errors.first('vehicleBillPhoto')">
                    </b-form-file><br><br>
                    <b-button variant="secondary" @click="hideModal">
                        <font-awesome-icon icon="times" class="text-white"/> Cancel
                    </b-button>
                    <b-button variant="primary" class="float-right" type="submit">
                        <font-awesome-icon icon="save"/> Submit
                    </b-button>
                </form>
            </b-modal>
            <b-modal ref="my-modal" centered hide-footer :title="'Edit'">
            <form v-on:submit.prevent="doSubmit()">
                <label>Bill Number *</label>
                <b-form-input :required="true" for-input="billNumber" type="text" name="billNumber" id="billNumber" label="Bill Number" placeholder="Enter Bill Number" v-validate="modelValidations.billNumber" :error="errors.first('billNumber')" v-model="model.billNumber" data-vv-as="billNumber"/><br>
                <label v-if="model.type === 'Repair'">Repair Date *</label>
                <label v-else-if="model.type === 'Service'">Service Date *</label>
                <label v-else-if="model.type === 'Penalty'">Penalty Date *</label>
                <b-form-datepicker
                id="typeDate"
                name="typeDate"
                v-model="typeDate"
                v-validate="modelValidations.typeDate"
                v-bind:class="errors.has('typeDate') ? 'is-invalid':''"
                locale="en-US"
                placeholder="No Date Selected"
                ></b-form-datepicker><br>
                <label>Amount *</label>
                <b-form-input :required="true" for-input="amount" type="text" name="amount" id="amount" label="Amount" placeholder="Enter Amount" v-validate="modelValidations.amount" :error="errors.first('amount')" v-model="model.amount" data-vv-as="amount"/><br>
                <label>Vehicle Bill Photo *</label>
                <div class="expander">
                <b-form-file :required="true" label="Photo" for-input="photoinputGroupFile" :error="errors.first('photoBill1')" v-model="model.photoBill1">
                    <div class="input-group">
                    <div class="custom-file">
                        <b-form-input type="file" class="custom-file-input" ref="photoBill1" @change="onFileSelectedPhoto" id="photoinputGroupFile" accept="image/jpeg, image/png, image/jpg" name="photoBill1" v-validate="modelValidations.photoBill1" :error="errors.first('photoBill1')" data-vv-as="photoBill1"/>
                        <label class="custom-file-label" for="photoinputGroupFile">{{model.photoBill1}}</label>
                    </div>
                    <div v-if="model.photoBill1 !== null" class="input-group-append">
                        <span class="input-group-text bg-danger text-white pointer" title="Clear Image" @click="clearImagePhoto"><font-awesome-icon icon="times"/></span>
                    </div>
                    </div>
                </b-form-file>
                </div><br>
                <label>Note *</label>
                <b-form-input :required="true" for-input="note" type="text" name="note" id="note" label="Note" placeholder="Enter Note" v-validate="modelValidations.note" :error="errors.first('note')" v-model="model.note" data-vv-as="note"/><br>
                <b-button variant="primary" class="btn-back float-right" type="submit"><font-awesome-icon icon="save"></font-awesome-icon> Submit </b-button>
                <b-button variant="secondary" class="float-left mr-3" @click="hideModal"><font-awesome-icon icon="times-circle"></font-awesome-icon> Cancel</b-button>
            </form>
            </b-modal>
            <b-button class="mt-3" @click="goBack" variant="secondary"><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button>
            <b-button class="mt-3 float-right" @click="showModal()" variant="warning"><font-awesome-icon icon="pencil-alt"></font-awesome-icon> Edit</b-button>
        </template>
    </b-card>
</template>

<script>
    import 'viewerjs/dist/viewer.css'
    import Viewer from 'v-viewer'
    import Vue from 'vue'
    Vue.use(Viewer)

    export default {
        name: 'vehicle-show',
        data () {
            return {
                isLoading: false,
                activeTab: 'Road Tax',
                apiUrl: {
                    vehicleBillInfo: window.AppConfig.apiUrl + 'vehicle-bill-info',
                },
                model: {
                    options: [],
                    type: null,
                    vehicle: null,
                    billNumber: null,
                    paidDate: null,
                    amount: null,
                    vehicleBillPhoto: null,
                    note: null,
                    merk: '',
                    model: '',
                    status: null,
                    year: '',
                    plate: '',
                    photo1: null,
                    photo2: null,
                    photo3: null,
                    roadtax: '',
                    note: '',
                    vehiclePhotoList: []
                },
                typeDate: null,
                data: {
                    vehicleBillPhoto: null
                },
                modelValidations: {
                    typeDate: {
                        required: true
                    },
                    photo1: {
                        required: false
                    },
                    photo2: {
                        required: false
                    },
                    photo3: {
                        required: false
                    }
                },
                vehicleRequestList: []
            }
        },
        mounted () {
            this.getDetail()
        },
        methods: {
            getDetail () {
                this.isLoading = true
                this.$http.get(this.apiUrl.vehicleBillInfo + '/' + this.$route.params.uuid)
                .then(response => {
                    this.model.type = response.data.type !== null ? response.data.type : '-'
                    this.model.vehicle = response.data.vehicle !== null ? response.data.vehicle : null
                    this.model.billNumber = response.data.billNumber !== null ? response.data.billNumber : '-'
                    this.model.options = response.data.options !== null ? response.data.options[0].value : '-'
                    this.model.paidDate = response.data.paidDate !== null ? this.getDateTime(response.data.paidDate) : '-'
                    this.model.amount = response.data.amount !== null ? response.data.amount : '-'
                    this.model.vehicleBillPhoto = response.data.vehicleBillPhoto !== null ? response.data.vehicleBillPhoto[0].url : null
                    this.model.note = response.data.note !== null ? response.data.note : '-'

                    this.model.status = response.data.status !== null ? response.data.status : '-'
                    this.model.createdAt = this.$moment(response.data.createdAt).format('YYYY-MM-DD hh:mm a')
                    this.model.updatedAt = response.data.updatedAt
                    this.model.uuid = response.data.uuid
                    this.model.vehiclePhotoList = []
                    if (response.data.vehicleBillPhoto !== null) {
                        response.data.vehicleBillPhoto.forEach(data => {
                            this.model.vehiclePhotoList.push(data.url)
                        })
                    }
                    this.isLoading = false
                })
                .catch(error => {
                    this.isLoading = false
                    this.$store.dispatch('notification/error', error)
                    // this.$router.push('/notfound')
                })
            },
            doSubmit() {
                this.$validator.validateAll().then(res => {
                if (res) {
                    this.isLoading = true
                    if (this.model.type==="Service") {
                        let typeDate = {name: "ServiceDate", value: this.typeDate};
                        this.model.options.push(typeDate)
                    } else if (this.model.type==="Penalty") {
                        let typeDate = {name: "PenaltyDate", value: this.typeDate};
                        this.model.options.push(typeDate)
                    } else if (this.model.type==="Road Tax") {
                        let typeDate = {name: "RoadTaxDate", value: this.typeDate};
                        this.model.options.push(typeDate)
                    } else { 
                        let typeDate = {name: "RepairDate", value: this.typeDate};
                        this.model.options.push(typeDate)
                    }

                    let formData = new FormData()
                    formData.append('billNumber', this.model.billNumber)
                    formData.append('amount', this.model.amount)
                    formData.append('options', JSON.stringify(this.model.options))
                    // formData.append('repairDate', this.model.repairDate)
                    formData.append('note', this.model.note)
                    if (this.model.photoBill1 !== null) {
                    formData.append('photoBill1', this.model.photoBill1)
                    }
                    if (this.model.uuid !== null) {
                    let model = {}
                    Object.keys(this.model).forEach(element => {
                        if (element !== 'uuid') {
                        model[element] = this.model[element]
                        }
                    })
                    this.$http.patch(this.apiUrl.vehicleBillInfo + '/' + this.model.uuid, formData).then(response => {
                        this.isLoading = false
                        this.$store.dispatch('notification/success', type + ' Data successfully updated.')
                        this.getDetail()
                        this.hideModal()
                        this.resetData()
                    }).catch(error => {
                        this.isLoading = false
                        this.$store.dispatch('notification/error', error)
                    })
                    }
                }
                })
            },
            doSendPhoto () {
                this.$validator.validateAll().then(res => {
                    if (res) {
                        let formData = new FormData()
                        formData.append('uuid', this.$route.params.uuid)
                        formData.append('photoBill1', this.model.vehicleBillPhoto)
                        this.$http.post(window.AppConfig.apiUrl + 'vehicle-bill-info?type=Service', formData).then(response => {
                            this.$store.dispatch('notification/success', 'Service photo has been added.')
                            this.getDetail()
                            this.hideModal()
                        }).catch(error => {
                            this.$store.dispatch('notification/error', error)
                        })
                    }
                })
            },
            doExportToExcel () {
              let url = window.AppConfig.apiUrl + '' + '?token=' + this.$store.getters['account/tokens'].access_token + '&requested_by=' + this.$route.params.uuid
            //   let url = window.AppConfig.apiUrl + '' + '?token=' + this.$store.getters['account/tokens'].access_token + '&requested_by=' + this.$route.params.uuid + '&status=' + this.$route.query.status + '&start_date=' + this.$route.query.start_date + '&end_date=' + this.$route.query.end_date
            //   console.log(url)
              window.open(url)
            },
            formatPrice(value) {
                let val = (value/1).toFixed(2).replace(',', '.')
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            },
            resetData () {
                this.model.uuid = null
                this.typeDate = null
                this.model.photoBill1 = null
                this.model.note = null
                this.model.amount = null
                this.model.billNumber = null
                this.$validator.reset()
            },
            showModal(row) {
                this.model.uuid = row.uuid
                this.typeDate = row.options !== null ? this.getDate(row.options[0].value) : ''
                this.model.note = row.note
                this.model.amount = row.amount
                this.model.billNumber = row.billNumber
                this.$validator.reset();
                this.$refs['my-modal'].show()
            },
            onFileSelectedPhoto (event) {
                this.model.photo = event.target.files[0]
            },
            clearImagePhoto () {
                this.$refs.photoBill1.value = ''
                this.model.photoBill1 = null
            },
            hideModal () {
                this.resetData()
                this.$refs['my-modal'].hide()
            },
            getDateTime (value) {
                if (value !== null) {
                    return this.$moment(value).format('YYYY-MM-DD')
                } else {
                    return '-'
                }
            },
            getStatusColor (val) {
                switch (val) {
                case 'New':
                    return 'info'
                    // eslint-disable-next-line no-unreachable
                    break
                case 'Paid':
                    return 'primary'
                    // eslint-disable-next-line no-unreachable
                    break
                }
            },
            getStatusName (val) {
                switch (val) {
                case '0':
                    return 'Not Available'
                    // eslint-disable-next-line no-unreachable
                    break
                case '1':
                    return 'Available'
                    // eslint-disable-next-line no-unreachable
                    break
                case false:
                    return 'Optional'
                    // eslint-disable-next-line no-unreachable
                    break
                case true:
                    return 'Required'
                    // eslint-disable-next-line no-unreachable
                    break
                case 'New':
                    return 'Waiting for repair'
                    // eslint-disable-next-line no-unreachable
                    break
                case 'Paid':
                    return 'Paid'
                    // eslint-disable-next-line no-unreachable
                    break
                }
            },
            getDate (value) {
                if (value !== null) {
                    return this.$moment(value).format('YYYY-MM-DD')
                } else {
                  return '-'
                }
            },
            goBack () {
                window.goBack(this)
            }
        }
    }
</script>